import { ScheduleItemData, VenueId } from '@beat-venues/common-types';
import { type VariantProps, cva } from 'class-variance-authority';
import { useTranslation } from 'next-i18next';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';
import { Heading } from '../heading';
import { Text } from '../text';

export interface TimingCardProps
    extends CommonProps,
        VariantProps<typeof TimingCardStyles> {
    title: string;
    venueId?: VenueId;
    timings: ScheduleItemData[];
}

export const TimingCardStyles = cva('rounded-lg bg-gray-500 p-8 min-w-72');

export const TimingCard = ({
    className,
    timings,
    title,
    venueId,
    testId = 'timing-card',
    ...props
}: TimingCardProps): JSX.Element => {
    const { t } = useTranslation('global');
    return (
        <div
            className={twMerge(TimingCardStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            {title && (
                <div className="mb-4">
                    <Heading as="h3" className="mb-0" size="h5">
                        {title}
                    </Heading>
                    {venueId && <Text>{t(`venues.${venueId}.name`)}</Text>}
                </div>
            )}

            <ul>
                {timings.map((timingItem, index) => (
                    <li key={index} className="flex justify-between">
                        <Text className="mr-5 truncate">
                            {timingItem.label}
                        </Text>
                        <Text>{timingItem.time}</Text>
                    </li>
                ))}
            </ul>
        </div>
    );
};
